import { TelemetryLogger } from "@/logger";
import { extractResponseError } from "./extract";

export const createFetch = (): typeof fetch => {
  return async (input, init) => {
    const startTime = performance.now();
    const url =
      typeof input === "string" ? input : input instanceof URL ? input.toString() : input.url;
    const method = init?.method || "GET";

    try {
      // Ensure credentials are included for authentication
      const response = await fetch(input, {
        ...init,
        credentials: "include", // Include cookies for authentication
      });

      const duration = performance.now() - startTime;

      if (!response.ok) {
        const errorData = await response.json();

        // TEMPORARY DEBUG: Log to console
        // console.error("API Error:", {
        //   url,
        //   method,
        //   status: response.status,
        //   errorData,
        // });

        // Log failed requests to Better Stack
        TelemetryLogger.logNetworkRequest({
          method,
          url,
          status: response.status,
          duration,
          responseBody: errorData,
        });

        throw errorData;
      }

      return response;
    } catch (error) {
      const duration = performance.now() - startTime;

      // TEMPORARY DEBUG: Log to console
      // console.error("Network Error:", {
      //   url,
      //   method,
      //   error,
      //   errorType: error?.constructor?.name,
      // });

      // Log network failures (timeouts, connection errors, etc.)
      TelemetryLogger.logNetworkRequest({
        method,
        url,
        duration,
        error: error instanceof Error ? error : String(error),
      });

      throw extractResponseError(error);
    }
  };
};
